// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"412e2cc2","532":"b8bde79b","589":"6c1c5de3","659":"99f33ab0","787":"9c881767","820":"b62d9b9f"}[chunkId] + ".chunk.js";
};